'use strict';

let $billDateKeep, $billDateNom, $formObj, sageAPIAccess;

function billingExportToggle(exportDisable){
    // Toggle export enabled or disabled
    if (exportDisable){
        $formObj.find('[name="InvoiceDate_ID"]').attr('disabled','disabled');
        $formObj.find('[name="Package"]').attr('disabled','disabled');
        $formObj.find('#btnExportInvoices').button('disable');
        $formObj.find('#billingAdvOpt').customHide();
        $formObj.find('.advancedFilters').customHide();
    } else {
        $formObj.find('[name="InvoiceDate_ID"]').removeAttr('disabled');
        $formObj.find('[name="Package"]').removeAttr('disabled');
        $formObj.find('#btnExportInvoices').button('enable');
        $formObj.find('#billingAdvOpt').customShow();
    }
}

export function showHideInactiveStallions()
{
    var activeStallionSelected = $formObj.find("[name='stallionID']")
        .find(':selected')
        .hasClass('activeStallion');

    if ($('#activeStallionsOnly').attr('checked')){
        if (!activeStallionSelected){
            $formObj.find("[name='stallionID']").val('');
        }
        $formObj.find("[name='stallionID']").find('.inActiveStallion').addClass('hide');
    }
    else {
        $formObj.find("[name='stallionID']").find('.inActiveStallion').removeClass('hide');
    }
}

export function populateExportBillingDates(){

    var invoiceType = $formObj.find('[name="invoiceType"]:checked').val();
    var billingCentreId = $formObj.find('[name="BillingCentre_ID"]').val();
    $formObj.find('[name="InvoiceDate_ID"]').empty();

    if (!billingCentreId > 0){
        return false;
    }

    if (invoiceType == 'stallion'){
        var invoiceDateUrl 	= '/components/appsnoms.cfc?'
            + jQuery.param({
                method: 'getInvoiceHistoryDates',
                billingCentreId: billingCentreId,
            });

        var lastBillingDate = $billDateNom;
    } else {
        var invoiceDateUrl 	= '/components/ledger.cfc?'
            + jQuery.param({
                method: 'getInvoiceHistoryDates',
                billingCentreId: billingCentreId,
            });
        var lastBillingDate = $billDateKeep;
    }

    $.ajax({
        type: 'GET',
        url: invoiceDateUrl,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data) {
            var $dropDownObj = $formObj.find('[name="InvoiceDate_ID"]');

            if (data.length < 1){
                $dropDownObj.append('<option value="">::No Invoices::</option>')
                    .attr('disabled','disabled');
                $formObj.find('.noInvoicesWarningText').customShow();
                billingExportToggle(true);
            } else {
                $dropDownObj.append('<option value="">::Choose Date::</option>')
                    .removeAttr('disabled');
                $formObj.find('.noInvoicesWarningText').customHide();
                billingExportToggle(false);
            }

            for (var i = 0; i < data.length; i++){

                // Create a new option element
                const option = document.createElement('option');
                option.value = data[i][1];
                option.text = data[i][0];
                if (option.value == lastBillingDate) {
                    option.selected = true;
                } else {
                    option.selected = false;
                }
                // Append the option to the select element
                $dropDownObj.append(option);

            }

            getBillingExportCategories(lastBillingDate);
            getBillingExportBatches({
                date: lastBillingDate,
            });

            if (sageAPIAccess){
                var sageGridURL	= '/components/sageAPI.cfc?'
                    + jQuery.param({
                        method: 'invoiceErrorCheck',
                        date: lastBillingDate,
                    });
                $('#invoiceErrorCheck')
                    .setGridParam({url: sageGridURL})
                    .trigger('reloadGrid');
            }
        },
    });
}

export function showPackageHints()
{
    var accPackage = $formObj.find('[name="Package"]:checked').val();
    var chargeTax = $formObj.find('[name="BillingCentre_ID"]:selected').attr('chargeTax');

    if (chargeTax == 0){
        $formObj.find('[id="ExceptCode_container"]:hidden').customShow();
    } else {

        $formObj.find('[id="ExceptCode_container"]:visible').customHide();
    }

    //$('#AcReceivable').val('');
    $formObj.find('[id="Account_Container"]').customHide();
    $formObj.find('[id="FileType_Container"]').customHide();
    $formObj.find('[id="hint_filetype"]').customHide();
    $formObj.find('.js-qbooksonline-only').customHide();
    $formObj.find('.js-sage-only').customHide();
    $formObj.find('.js-nav-only').customHide();
    $formObj.find('.js-xero-only').customHide();
    $formObj.find('.js-pastel-only').customHide();
    $formObj.find('.js-landmark-only').customHide();
    $formObj.find('.js-sage200grange-only').customHide();
    $formObj.find('.js-sage200islanmore-only').customHide();
    $formObj.find('.js-sageone-only').customHide();
    $formObj.find('.js-greatplainsopera-only').customHide();
    $formObj.find('.js-thesaurus-only').customHide();
    $formObj.find('.js-thesaurustype-only').customHide();
    $formObj.find('.js-CEGID-only').customHide();
    $formObj.find('.js-EBP-only').customHide();
    $formObj.find('.EBPWarning').customHide();
    $formObj.find('[id="invoiceErrorCheckContainer"]').customHide();
    $formObj.find('.invoiceErrorMessage').customHide();
    if (accPackage != 'SageOnline'){
        $formObj.find('[id="btnExportInvoices"]').button({ disabled: false });
    }
    $formObj.find('.sageOnlineInfo').customHide();

    if (accPackage == 'Quickbooks')
    {
        //$('#AcReceivable').val('<cfoutput>#settingAcReceivable#</cfoutput>');
        $formObj.find('[id="Account_Container"]:hidden').customShow();
        $formObj.find('[id="FileType_Container"]:hidden').customShow();
        $formObj.find('[id="hint_filetype"]:hidden').customShow();
    }
    else
    {
        if (accPackage == 'QuickbooksOnline') {
            $formObj.find('.js-qbooksonline-only').customShow();
        }
        else if (accPackage == 'Sage') {
            $formObj.find('.js-sage-only').customShow();
        }
        else if (accPackage == 'Xero'){
            $formObj.find('.js-xero-only').customShow();
        }
        else if ((accPackage == 'Pastel') | (accPackage == 'NewPastel')){
            $formObj.find('.js-pastel-only').customShow();
        }
        else if (accPackage == 'Landmark') {
            $formObj.find('.js-landmark-only').customShow();
        }
        else if (accPackage == 'SageOne') {
            $formObj.find('.js-sageone-only').customShow();
        }
        else if (accPackage == 'Sage200Grange') {
            $formObj.find('.js-sage200grange-only').customShow();
        }
        else if (accPackage == 'Sage200Islanmore') {
            $formObj.find('.js-sage200islanmore-only').customShow();
        }
        else if (accPackage == 'POMO') {

        }
        else if (accPackage == 'EBP') {

        }
        else if ((accPackage == 'CEGID') | (accPackage == 'CEGIDTrade')) {
            $formObj.find('.js-CEGID-only').customShow();
        }
        else if (accPackage == 'Thesaurus') {
            $formObj.find('.js-thesaurustype-only').customShow();
            $formObj.find('.js-thesaurus-only').customShow();
        }
        else if (accPackage == 'GreatPlainsOpera') {
            $formObj.find('.js-greatplainsopera-only').customShow();
        }
        else if (accPackage == 'SageOnline') {
            $formObj.find('[id="btnExportInvoices"]').button({ disabled: true });
            if (sageAPIAccess){
                $formObj.find('[id="invoiceErrorCheckContainer"]').customShow();
                $formObj.find('[id="invoiceErrorCheck"]').trigger('reloadGrid');
            }
            else {
                $formObj.find('.sageOnlineInfo').customShow();
            }
        }
        else
        {
            $formObj.find('[id="Account_Container"]:hidden').customShow();
        }
    }
}

export function pastelPreCheck($formObj, unMatchedRecordsOnly){

    var pastelStart, missingItemResultMsg, pastelURL, recordCount, popURL;

    var invoiceType = $formObj.find('[name="invoiceType"]:checked').val();
    var invoiceDate = $formObj.find('[name="InvoiceDate_ID"] option:selected').val();
    pastelStart = $formObj.find('[name="pastel_start"]').val();

    if (pastelStart == ''){
        EQLAPP.STRIPE.showAlert({title: 'Alert',body: 'Please select the Pastel Start Period'});
    }
    else {
        pastelURL = '/components/billing.cfc?'
                            + jQuery.param({
                                method: 'getInvoiceHistoryExportQ',
                                invoiceType: invoiceType,
                                invoiceDate: invoiceDate,
                                minAccountLinkLength: 1,
                                maxAccountLinkLength: 7,
                                minNominalCodeLength: 1,
                                maxNominalCodeLength: 7,
                                unMatchedRecordsOnly: unMatchedRecordsOnly,
                                missingItemResultMsg: missingItemResultMsg,
                            });

        $.ajax({
            type: 'GET',
            url: pastelURL,
            data: gen_random(),
            dataType: 'JSON',
            cache: false,
            success: function(data)
            {
                recordCount = data.RECORDCOUNT;

                if (unMatchedRecordsOnly){

                    if (recordCount > 0){
                        popURL = '/pages/ajax_generic_window.cfm?'
                                    + jQuery.param({
                                        type: 'pop_billing_pastel_missing_items',
                                        invoiceType: invoiceType,
                                        invoiceDate: invoiceDate,
                                    });

                        popWin({
                            popID: 'pastelExcludedItems',
                            title: 'Pastel Excluded Items',
                            classes: 'js-pastelExcludedItems',
                            noAutoWidth: true,
                            width: 380,
                            height: 310,
                            modal: true,
                            page: popURL,
                        });
                    }
                    else {
                        saveForm(formID);
                    }
                }

            },
        });
    }


}

export function init(options) {

    if (!options) { options = {}; }
    if (!options.billDateKeep) {
        options.billDateKeep = '';
    }
    if (!options.billDateNom) {
        options.billDateNom = '';
    }
    if (!options.formObj) {
        options.formObj = '';
    }

    // Save Key Objects
    $billDateKeep = options.billDateKeep;
    $billDateNom = options.billDateNom;
    $formObj = options.formObj;
    sageAPIAccess = $formObj.data('sage-api');

}

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

if (window.EQLAPP) {
    window.EQLAPP.BILLINGEXPORT = window.EQLAPP.BILLINGEXPORT || {};
    window.EQLAPP.BILLINGEXPORT.init = init;
    window.EQLAPP.BILLINGEXPORT.populateExportBillingDates = populateExportBillingDates;
    window.EQLAPP.BILLINGEXPORT.showPackageHints = showPackageHints;
    window.EQLAPP.BILLINGEXPORT.pastelPreCheck = pastelPreCheck;
}